import { createSelector } from "reselect"
import { get, pickBy, chain, first, includes, filter } from "lodash"
import { getAllRawFactorsCategories, getDecompositionType, getIsModelFactorsUsed, getFactorsData, getIsContentSet } from "."

export const getSelectedCategory = state => get(state, "modules.rebalance.selectedCategory")

const getContentSetFactorCategories = createSelector(
  [getAllRawFactorsCategories, getIsContentSet, getDecompositionType],
  (categories, isContentSet, type) => isContentSet ? filter(categories, category => category.contentSetId === type) : null,
)

const getModelFactorCategories = createSelector(
  [getAllRawFactorsCategories],
  (categories) => chain(categories)
    .filter(category => category.isRiskModelCategory)
    .orderBy("singleFactor", "asc")
    .value(),
)

export const getFactorsCategories = createSelector(
  [getModelFactorCategories, getContentSetFactorCategories, getDecompositionType],
  (categories, contentSetFactorCategories, type) => {
    // Beta and Marginal contributions do not have categories
    if (includes(["beta", "marginal"], type)) {
      return null
    }

    return contentSetFactorCategories || categories
  },
)

const getFactors = createSelector(
  [getFactorsData, getDecompositionType, getIsModelFactorsUsed],
  (allFactors, decompositionType, isModelFactorsUsed) => isModelFactorsUsed ? allFactors.model : get(allFactors, decompositionType),
)

export const getSelectedCategoryFactors = createSelector(
  [getFactors, getSelectedCategory, getFactorsCategories],
  (factors, selectedCategory, categories) => {
    const categoryId = selectedCategory || get(first(categories), "id")

    return pickBy(factors, (factor) => factor.category === categoryId)
  },
)
